export default function IconArrow({color}) {
    
  return (
    <>
      <svg version="1.1" id="Layer_1" x="0px" y="0px"
	 viewBox="0 0 6.8 11.6">
<path fill={color}  d="M6.5,0.3c0.4,0.4,0.5,1,0,1.6L2.7,5.8l3.7,3.9c0.5,0.5,0.4,1.1,0,1.6c-0.4,0.4-1.2,0.4-1.6,0c-0.4-0.4-4.5-4.7-4.5-4.7
	C0.1,6.4,0,6.1,0,5.8S0.1,5.2,0.3,5c0,0,4.1-4.3,4.5-4.7S6-0.1,6.5,0.3z"/>
</svg>

    </>
  );
}